import React from "react";

import CircularProgress from "veneer/CircularProgress";
import Stack from "veneer/Stack";
import { Colors } from "veneer/Theme";
import Typography from "veneer/Typography";

interface TableDataLoaderProps {
  title?: string;
}

export function TableDataSpinner({
  title = "Loading data…",
}: TableDataLoaderProps) {
  return (
    <Stack
      alignItems="center"
      direction="row"
      justifyContent="center"
      spacing={1}
    >
      <CircularProgress size={15} />
      <Typography color={Colors.gray1000} component="span" variant="body2">
        {title}
      </Typography>
    </Stack>
  );
}
